<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!-- 視頻開始 -->
  <div class="hbody is-loading">
    <!-- 只渲染当前设备对应的轮播，不会加载另一套 -->
    <div v-if="isPC" class="topSwiper hidden-xs">
      <el-carousel
        v-if="topPCImage.length"
        :style="{ height: 'calc(100vh - 80px)' }"
        trigger="click"
        arrow="never"
      >
        <el-carousel-item v-for="item in topPCImage" :key="item.id">
          <h3 class="sImg">
            <img :src="item.url" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div v-else class="topSwiper visible-xs">
      <el-carousel
        v-if="topAZImage.length"
        :style="{ height: 'calc(100vh - 56px)' }"
        trigger="click"
        arrow="never"
      >
        <el-carousel-item v-for="item in topAZImage" :key="item.id">
          <h3 class="sImg">
            <img :src="item.url" alt />
          </h3>
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 關於開始 -->
    <section id="about">
      <div class="row about-wrap">
        <div class="col-full">
          <div class="about-profile-bg">
            <div class="intro">
              <h3 class="animate-this">華胤集團</h3>
              <p class="lead animate-this" style="text-align: left">
                華胤是專業在鋼結構之國際工程集團,提供客戶從規畫諮詢,設計優化,工程設計,製造安裝及項目管理之整體解決方案服務。華胤擁有自己的內部
                (in-house)設計團隊,成員由資深的工程師組成,可以協助客戶在項目規劃初期提供專業建議,供業者決策參考並持續優化設計以節省建築成本。除了提供海外投資建廠服務,華胤也致力於生產外銷一流品質鋼構產品,創立以來多次挑戰各種高品質及高難度之鋼結構加工製造,憑藉擁有多項國際品質系統認證實力,華胤鋼結構也透過與美商
                Fluor, M+W, 英商 Turner and Townsend, 德商 Thyssenkrupp
                及日商三菱重工 Mitsubishi, 森松重工 Morimatsu
                等世界知名國際工程總包合作,出口鋼構產品到全球五大洲之重要工程項目上。
              </p>
              <p class="lead animate-this" style="text-align: left">
                華胤集團1994年創立,
                30年來已經完成超過4000個鋼結構工程項目,擁有包括{{
                  jtrzList.length
                }}項國際權威認證,12項鋼結構專利,32項建築獎項等。華胤集團發展至第三代江蘇南通海安鋼結構工廠,廠內超過20項業界頂尖設備,面積佔地12.5萬平方米,年產能可達15萬噸鋼構件及3萬噸彩鋼成型構件。此外,福建廈門,台灣彰化,越南胡志明市,泰國曼谷亦有生產基地,並正在規劃於北美及印尼建置新產能。
              </p>
            </div>
          </div>
        </div>
        <!-- end col-full  -->
      </div>
      <!-- end about-wrap  -->
    </section>
    <!-- 關於結束 -->
    <!-- 榮譽開始 -->
    <div class="new-scheme-main" style="background-color: #e7e7e8">
      <p class="title">華胤集團{{ jtrzList.length }}項國際認證</p>

      <div
        class="full-screen-portfolio"
        id="portfolio"
        style="background-color: #e7e7e8"
      >
        <div class="container-fluid">
          <div
            class="col-lg-2 col-xs-4 ryfox"
            v-for="(item, index) in jtrzList"
            :key="index"
          >
            <div class="portfolio-item">
              <div class="thumb">
                <div class="image">
                  <div class="demo-image__preview">
                    <el-image
                      class="eImagebc"
                      :src="item.icon"
                      :preview-src-list="item.image"
                      lazy
                    >
                    </el-image>
                  </div>
                </div>
                <div class="hover-effect">
                  <div class="hover-content" style="white-space: pre-line">
                    <h1 class="hidden-xs">{{ item.text }}</h1>
                    <h1 class="visible-xs">{{ item.Atext }}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 榮譽結束 -->
    <div style="background-color: rgb(231, 231, 232)">
      <to-mail button-text="聯絡我們"></to-mail>
    </div>
  </div>
  <!-- 榮譽結束 -->
</template>

<script>
export default {
  data() {
    return {
      isPC: true, // 设备标识
      topPCImage: [
        { url: require('@/components/img/home/top1.jpg'), id: 0 },
        { url: require('@/components/img/home/top2.jpg'), id: 1 },
        { url: require('@/components/img/home/top3.jpg'), id: 2 },
        { url: require('@/components/img/home/top4.jpg'), id: 3 },
        { url: require('@/components/img/home/top5.jpg'), id: 4 },
        { url: require('@/components/img/home/top6.jpg'), id: 5 },
        { url: require('@/components/img/home/top7.jpg'), id: 6 },
        { url: require('@/components/img/home/top8.jpg'), id: 7 },
        { url: require('@/components/img/home/top9.jpg'), id: 8 },
        { url: require('@/components/img/home/top10.jpg'), id: 9 },
      ],
      topAZImage: [
        { url: require('@/components/img/home/Atop1.jpg'), id: 0 },
        { url: require('@/components/img/home/Atop2.jpg'), id: 1 },
        { url: require('@/components/img/home/Atop3.jpg'), id: 2 },
        { url: require('@/components/img/home/Atop4.jpg'), id: 3 },
        { url: require('@/components/img/home/Atop5.jpg'), id: 4 },
        { url: require('@/components/img/home/Atop6.jpg'), id: 5 },
        { url: require('@/components/img/home/Atop7.jpg'), id: 6 },
        { url: require('@/components/img/home/Atop8.jpg'), id: 7 },
        { url: require('@/components/img/home/Atop9.jpg'), id: 8 },
        { url: require('@/components/img/home/Atop10.jpg'), id: 9 },
      ],
      jtrzList: [
        {
          icon: require('@/components/img/home/image43.png'),
          image: [require('@/components/img/gyhy/zzzs5.png')],
          text: '美國鋼結構協會\nAISC',
          Atext: '美國鋼結構協會\nAISC',
        },
        {
          icon: require('@/components/img/home/image44.png'),
          image: [require('@/components/img/gyhy/zzzs8.png')],
          text: '美國焊接協會\nAWS',
          Atext: '美國焊接協會\nAWS',
        },
        {
          icon: require('@/components/img/home/image45.png'),
          image: [require('@/components/img/gyhy/zzzs6.png')],
          text: '加拿大焊接協會\nCWB\nCSA W47.1-D1',
          Atext: '加拿大焊接協會\nCWB\nCSA W47.1-D1',
        },
        {
          icon: require('@/components/img/home/image53.png'),
          image: [require('@/components/img/gyhy/zzzs16.png')],
          text: '加拿大鋼構系統\n製造商認證\nCSA A660-10',
          Atext: '加拿大鋼構系統製造商認證\nCSA A660-10',
        },
        {
          icon: require('@/components/img/home/image46.png'),
          image: [require('@/components/img/gyhy/zzzs10-1.png')],
          text: '歐盟鋼結構品質標準\nEN1090-1\nEXC3',
          Atext: '歐盟鋼結構\n品質標準\nEN1090-1\nEXC3',
        },
        {
          icon: require('@/components/img/home/image46-2.png'),
          image: [require('@/components/img/gyhy/zzzs10-2.png')],
          text: '歐盟鋼結構品質標準\nEN1090-2\nEXC3',
          Atext: '歐盟鋼結構\n品質標準\nEN1090-2\nEXC3',
        },
        {
          icon: require('@/components/img/home/image48.png'),
          image: [require('@/components/img/gyhy/zzzs9.png')],
          text: '中國鋼構\n一級資質',
          Atext: '中國鋼構\n一級資質',
        },
        {
          icon: require('@/components/img/home/image52.png'),
          image: [require('@/components/img/gyhy/zzzs11.png')],
          text: '國際焊接質量控制\n標準體系 ISO 3834',
          Atext: '國際焊接質量\n控制標準體系\nISO 3834',
        },
        {
          icon: require('@/components/img/home/image49.png'),
          image: [
            require('@/components/img/gyhy/zzzs13.png'),
            require('@/components/img/gyhy/zzzs12.png'),
          ],
          text: '歐盟建設工程鋼結構\n設計生產 ISO 9001',
          Atext: '歐盟建設工程鋼結構設計生產\nISO 9001',
        },
        {
          icon: require('@/components/img/home/image50.png'),
          image: [
            require('@/components/img/gyhy/zzzsen2.png'),
            require('@/components/img/gyhy/zzzs2.png'),
            require('@/components/img/gyhy/zzzs4.png'),
          ],
          text: '歐盟職業安全管理\nISO 45001',
          Atext: '歐盟職業\n安全管理\nISO 45001',
        },
        {
          icon: require('@/components/img/home/image51.png'),
          image: [
            require('@/components/img/gyhy/zzzsen1.png'),
            require('@/components/img/gyhy/zzzs1.png'),
            require('@/components/img/gyhy/zzzs3.png'),
          ],
          text: '歐盟環境管理系統\nISO 14001',
          Atext: '歐盟環境\n管理系統\nISO 14001',
        },
        {
          icon: require('@/components/img/home/image47.png'),
          image: [
            require('@/components/img/gyhy/zzzs14.png'),
            require('@/components/img/gyhy/zzzs15.png'),
          ],
          text: '日本國土交通省認定\n鐵骨制作 JSA\nH-Grade',
          Atext: '日本國土交通省認定鐵骨制作 JSA\nH-Grade',
        },
      ],
    }
  },
  created() {
    // 判断设备：PC / 移动端
    this.checkDevice()
  },
  methods: {
    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // 匹配手机设备
      const mobileRegex =
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
      this.isPC = !mobileRegex.test(userAgent)
    },

    // 只预加载当前设备需要的图片
    async preloadImages() {
      const imageList = this.isPC ? this.topPCImage : this.topAZImage
      const promises = imageList.map((item) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.src = item.url
          img.onload = resolve
          img.onerror = resolve
        })
      })
      await Promise.all(promises)
    },
  },
  mounted() {
    this.preloadImages().then(() => {
      // 图片预加载完成后逻辑
    })
  },
}
</script>
<style scoped>
@import url('@/views/Home/css/templatemo-style.css');
.titleTo {
  font-size: 13px;
  color: #ccc;
  text-align: center;
  margin: 20px 0 -30px 0;
  cursor: pointer;
}
.full-screen-portfolio {
  background-color: #e7e7e8;
  padding: 40px 80px;
}
.hover-content {
  height: 120px;
}
.hover-content h1 {
  margin: 10px 0;
}

/* line */
.ul::before {
  content: '';
  grid-column: 1;
  grid-row: 1 / span 20;
  background: rgb(225, 225, 225);
  border-radius: calc(var(--line-w) / 2);
}

/*轮播图*/
.topSwiper {
  z-index: 9999;
  height: calc(100vh - 80px);
  width: 100%;
}
div /deep/ .el-carousel__container {
  height: calc(100vh - 80px);
}

div /deep/ .el-carousel__indicators--horizontal {
  bottom: 20px;
}

div /deep/ .el-carousel__button {
  height: 10px;
}

.el-carousel__item h3 {
  opacity: 1;
  margin: 0;
  text-align: center;
}
.el-carousel__item h3 span {
  z-index: 999;
  display: inline-block;
  width: fit-content;
  position: absolute;
  height: 80px;
  bottom: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  color: #fff;
  font-size: 50px;
  text-align: center;
  letter-spacing: 1.5px;
  font-weight: 400;
  line-height: 80px;
}

.sImg img {
  width: 100%;
  height: calc(100vh - 80px);
}

.double-border {
  width: auto;
  position: relative;
  border: 2px solid #fff;
  padding: 5px;
}
/* 外邊框樣式 */
.double-border::before {
  content: '';
  position: absolute;
  width: 40px;
  height: 40px;
  transition: 0.3s ease-in-out;
  top: -8px;
  left: -8px;
  border-top: 2px solid #fff;
  border-left: 2px solid #fff;
}
.double-border::after {
  content: '';
  position: absolute;
  width: 40px;
  height: 40px;
  transition: 0.3s ease-in-out;
  right: -8px;
  bottom: -8px;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
}
.box {
  z-index: 999;
  display: inline-block;
  width: fit-content;
  position: absolute;
  height: 80px;
  bottom: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  width: 80vw;
  height: 100px;
  background-color: rgba(192, 192, 192, 0.7);
}
/*/~ 重置轮播动画 ~/
.el-carousel__item {
  transition: transform 0.8s cubic-bezier(0.23, 1, 0.32, 1) !important;
}*/

.col-lg-2 {
  padding-left: 5px;
  padding-right: 5px;
}

.eImagebc {
  width: 100%;
  background-color: #fff;
  border: 2px solid #ccc;
}

@media screen and (max-width: 1400px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 18px;
    font-weight: normal;
  }
  .swiper-container {
    width: 100%;
    height: 300px;
    position: relative;
  }
  .swip {
    height: 300px;
  }
  .swiper-image {
    width: 100vw;
    height: 300px;
  }
  .overlay {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 5px;
    border-radius: 10px;
    color: white;
  }
  .altitle {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .text {
    font-size: 10px;
    margin: 10px 0;
  }
  .details {
    font-size: 13px;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  .scrm {
    padding: 0 5px;
  }
  .ryfox {
    padding: 0 10px;
  }
  .hover-content h1 {
    margin: 10px 0 0 0;
  }
  #about h3 {
    font-size: 26px;
  }
  .topSwiper {
    height: calc(100vh - 80px);
  }
  div /deep/ .el-carousel__container {
    height: calc(100vh - 80px);
  }

  div /deep/ .el-carousel__indicators--horizontal {
    bottom: 7px;
    width: max-content;
  }

  div /deep/ .el-carousel__button {
    width: 20px;
    height: 7px;
  }
  .sImg img {
    width: 100%;
    height: calc(100vh - 80px);
  }
  #about {
    padding: 40px 0 60px 0;
  }
  #about .lead {
    font-size: 18px;
    line-height: 2;
    color: #000;
    width: 90vw;
    margin: 10px auto;
  }
  .new-scheme-main {
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .full-screen-portfolio {
    padding: 15px 40px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    line-height: 25px;
  }
  div /deep/ .portfolio-item img {
    height: 24vw;
  }
  .hover-content {
    height: 100px;
  }
  .new-scheme-main .title {
    font-size: 25px;
  }
}

@media screen and (max-width: 768px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 13px;
    font-weight: normal;
  }
  .swiper-container {
    width: 100%;
    height: 300px;
    position: relative;
  }
  .swip {
    height: 300px;
  }
  .swiper-image {
    width: 100vw;
    height: 300px;
  }
  .overlay {
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    padding: 5px;
    border-radius: 10px;
    color: white;
  }
  .altitle {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .text {
    font-size: 10px;
    margin: 10px 0;
  }
  .details {
    font-size: 13px;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 5px;
    border-radius: 5px;
    cursor: pointer;
  }
  .scrm {
    padding: 0 5px;
  }
  .ryfox {
    padding: 0 2px;
  }
  .hover-content h1 {
    margin: 5px 0;
  }
  #about h3 {
    font-size: 22px;
  }
  .topSwiper {
    height: calc(100vh - 56px);
  }
  div /deep/ .el-carousel__container {
    height: calc(100vh - 56px);
  }

  div /deep/ .el-carousel__indicators--horizontal {
    bottom: 10px;
    width: max-content;
  }

  div /deep/ .el-carousel__button {
    width: 15px;
    height: 5px;
  }
  .sImg img {
    width: 100%;
    height: calc(100vh - 56px);
  }
  #about {
    padding: 50px 0 60px 0;
  }
  #about .lead {
    font-size: 13px;
    line-height: 2;
    color: #000;
    width: 90vw;
    margin: 10px auto;
  }
  .new-scheme-main {
    width: 100%;
    padding: 40px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .full-screen-portfolio {
    padding: 10px 5px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    line-height: 20px;
  }
  div /deep/ .portfolio-item img {
    height: 100px;
  }
  .hover-content {
    height: 100px;
  }
  .new-scheme-main .title {
    font-size: 22px;
  }
}
@media screen and (min-width: 2000px) {
  .full-screen-portfolio .portfolio-item h1 {
    font-size: 26px;
    font-weight: normal;
  }
  .ryfox {
    padding: 0 10px;
  }
  .hover-content h1 {
    margin: 10px 0 0 0;
  }
  #about h3 {
    font-size: 40px;
  }
  .topSwiper {
    height: calc(100vh - 80px);
  }
  div /deep/ .el-carousel__container {
    height: calc(100vh - 80px);
  }

  div /deep/ .el-carousel__indicators--horizontal {
    bottom: 7px;
    width: max-content;
  }

  div /deep/ .el-carousel__button {
    width: 20px;
    height: 7px;
  }
  .sImg img {
    width: 100%;
    height: calc(100vh - 80px);
  }
  #about .lead {
    font-size: 30px;
    line-height: 2;
    color: #000;
    font-weight: 600;
  }
  .new-scheme-main {
    width: 100%;
    padding: 90px 0;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .full-screen-portfolio {
    padding: 60px 100px;
  }
  .full-screen-portfolio .portfolio-item h1 {
    line-height: 30px;
  }
  div /deep/ .portfolio-item img {
    height: 13vw;
  }
  .hover-content {
    height: 120px;
  }
  .new-scheme-main .title {
    font-size: 40px;
  }
}
</style>
